import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { get_Download_links } from "../../api/api";
import axios from "axios";
import { toast } from "react-toastify";
import Loading from "../Loading";
import { MdContentCopy, MdOutlineFileDownloadOff } from "react-icons/md";
import { RiDownload2Line } from "react-icons/ri";
import { FaShoppingBasket } from "react-icons/fa";
import { IoMdArrowBack } from "react-icons/io";
import { Helmet } from "react-helmet-async";
import { getDownloadLinkTitle } from "../../services/help";



const DownloadPage = () => {

    const [isLoading, setIsLoading] = useState(true)
    const [notFound, setNotFound] = useState(false)
    const [data, setData] = useState({})
    const [links, setLinks] = useState({})
    const [free, setFree] = useState(true)
    const [title, setTitle] = useState()

    const params = useParams()
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        const downloadId = parseInt(params.downloadId)

        const getContent = async () => {
            try {
                const res = await axios.get(get_Download_links(params.contentId, params.userId))
                // const pageTitle = await axios.get(Get_Subject_ID + params.contentId)

                if (res.data) {
                    setTitle(res.data[0]?.subjectTitle);
                    const subjectBranch = res.data
                    const filteredLinks = subjectBranch.filter(item => item.id === downloadId)[0]
                    if (filteredLinks) {
                        setLinks(filteredLinks)
                        filteredLinks.branchLinks[0].price > 0 ? setFree(false) : setFree(true)
                    } else {
                        setNotFound(true)
                    }
                }

                setData(res.data)
            } catch (err) {
                setNotFound(true)
            } finally {
                setIsLoading(false)
            }
        }
        getContent()


    }, []);


    const filteredLinks = (data) => {
        if (Object.keys(data).length > 0 && !notFound) {
            return data?.branchLinks[0]?.downloadLinks[0].links.map((item, i) => (
                <div key={i} className='boxdlLinks'>
                    <div className='topDLBox'>
                        <span>{getDownloadLinkTitle(item, i)}</span>
                        <small>{item.size} MB</small>
                    </div>
                    <div className='CopyLinkDL'>
                        <a target='_blank' href={item.link} className="download" style={{ fontSize: 15, textAlign: 'center', }}>{free ? <RiDownload2Line /> : <FaShoppingBasket />} {free ? 'دانلود' : 'خرید'}</a>
                        <button
                            style={{ width: '150px', display: 'flex', gap: '10px', alignItems: 'center', marginRight: '10px', fontSize: 15, fontWeight: 400 }}
                            onClick={() => {
                                navigator.clipboard.writeText(item.link)
                                toast.success('کپی شد', { autoClose: 700, theme: 'dark' })
                            }}
                        >
                            <MdContentCopy />
                            کپی لینک
                        </button>

                        <input type='text' value={item.link} readOnly />
                    </div>
                </div>
            ))
        }
    }


    return (
        isLoading ? <Loading /> : (
            <>
                {!notFound && <Helmet>
                    <title>دانلود {`${title} (${links.title})`}</title>
                </Helmet>}
                <div className="contentHolder content mini">
                    <div className="gobackArchive">
                        {location.key !== "default" && (
                            <button style={{ marginRight: 'auto', display: 'block', marginBottom: '25px' }} onClick={() => { navigate(-1) }}><span>بازگشت</span> <IoMdArrowBack /></button>
                        )}
                        {!notFound && (<h5 style={{ marginBottom: 0, display: 'flex', alignItems: 'center' }}>لینک های دانلود {title} <span style={{ background: '#ffebcd', borderRadius: '5px', padding: '1px 10px', margin: '10px' }}>{links.title}</span></h5>)}
                    </div>
                    <div className="itemBox single" style={{ display: 'block', marginBottom: 0 }}>
                        {notFound ? (<div style={{ textAlign: 'center', color: '#607d8b' }}>
                            <h1 style={{ fontSize: 50, marginBottom: 25 }}><MdOutlineFileDownloadOff /></h1>
                            <h5>لینک های دانلود پیدا نشد!</h5>
                        </div>) : (filteredLinks(links))}
                    </div>
                </div>
            </>
        )
    )
}

export default DownloadPage;